<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import downloader from '@/mixins/downloader';
import snackbarMixin from '@/mixins/snackbar';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';

export default {
  name: 'BlogEntryListItem',
  components: {
    RbxConfirmDialog,
  },
  mixins: [downloader, snackbarMixin],
  props: {
    blogEntry: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: 'Soll der Blogeintrag gelöscht werden?',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.isConfirmDialogDisplayed = false;

      axios.delete(`/blogEntry/${this.blogEntry.id}`)
        .then(() => {
          this.showSuccessMessage('Der Blogeintrag wurde gelöscht.');

          this.$emit('delete');
        })
        .catch(() => {
          this.showErrorMessage('Ein technischer Fehler ist aufgetreten. Der Löschvorgang ist fehlgeschlagen.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/blogEntryDetails/${blogEntry.id}`">{{ blogEntry.headline }}</router-link>
    </td>
    <td>
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="blogEntry.isDelete">
          <v-icon color="red lighten-2" small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </tr>
</template>
